import { useEffect, useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ parentcompany, fullcompanylist, accounts, formData, onInputChange,zoneWarehouseList }) => {

   

    return (
        <>
            <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>
                {/* check box */}
                <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                   

                    <div style={{ marginBottom: '12px', display: 'flex', flexDirection: 'column', gap: '5px', padding: '0 12px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400' }}>
                            <input
                                type="checkbox"
                                className="form-check-input me-2"
                                checked={formData.isRejectedWarehouse || false}
                                onChange={(e) => {
                                    console.log('Checkbox changed to:', e.target.checked);
                                    onInputChange('isRejectedWarehouse', e.target.checked);
                                }}
                                style={{
                                    width: '15px',
                                    height: '15px',
                                    backgroundColor: formData.isRejectedWarehouse ? '#270B79' : 'white',
                                    borderColor: '#270B79',
                                    cursor: 'pointer'
                                }}
                            />
                            Is Rejected Warehouse
                        </label>
                        <div style={{
                            fontSize: '12px',
                            color: '#6c757d',
                            marginLeft: '20px',
                            fontStyle: 'italic'
                        }}>
                            If yes, then this warehouse will be used to store rejected materials
                        </div>
                    </div>
                </div>
                {/* check box */}

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Bin Name"
                                label="Bin Name"
                                style={{ height: "30px" }}
                                value={formData.warehouseName}
                                onChange={(e) => onInputChange('warehouseName', e.target.value)}
                            />
                        </div>
                    </div>
                   
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={fullcompanylist || []}
                                label="Company"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.company}
                                onChange={(value) => onInputChange('company', value)}
                                placeholder=""
                            />
                        </div>
                    </div>


                     <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={zoneWarehouseList || []}
                                label="Parent Warehouse"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.parentWarehouse}
                                onChange={(value) => onInputChange('parentWarehouse', value)}
                                placeholder=""
                            />

                            



{/* 
<td className="p-0 d-flex justify-content-center" style={{ position: "relative", border: '1px solid rgb(206, 212, 218)',
    borderRadius: '7px' }}>
                  
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', height: '28.4px', textAlign: 'center' }}                    
                    onFocus={() => {
                      getItemdata();
                        setTimeout(() => {
                            setShowDropdown(true);
                        }, 302);
                        }}

                    onBlur={() => { setTimeout(() => {setShowDropdown(false);}, 200) }}
                    onChange={(e) => {
                        setsearch_input(e.target.value);
                        getItemdata(0, e.target.value);
                        updateRow("item_code", e.target.value);
                    
                    }}
                    

                    onKeyDown={(e) => {
  if (showDropdown === true && item_list.length > 0) {
    if (e.key === "Enter") {
      e.preventDefault();
      const selectedItem = item_list[0]; 

      updateRow("item","");

      setsearch_input("");
    }
  }
}}


                     value={
                search_input !== "" && showDropdown === true ? search_input : showDropdown === true && search_input === ""
                  ? "" : parentzonevalue
                   }
 />

                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      maxHeight: showDropdown === true ? "200px" : "0",
                      display: showDropdown === true ? '' : 'none',
                      overflowY: "auto",
                      background: "white",
                      border: showDropdown === true ? "1px solid #ccc" : "",
                      zIndex: 10,
                    }}
                  >
                    {item_list.map((item, idx) => (
                      <div key={idx}

    // onMouseDown={() => handleSelect(item)}
                        className="text-start"
                       onClick={() => {

  updateRow("item","");

  setsearch_input("");
  setShowDropdown(false);
}}

                   style={{
  padding: "8px",
  cursor: "pointer",
  borderBottom: "1px solid #eee",
  backgroundColor: "white",
}}
                      >
                        <p className="m-0">
                          {item.item_code}
                        </p>
                        <div style={{ fontSize: '10px' }}>
                          {item?.item_name}, {item?.item_group}
                        </div>
                      </div>
                    ))}
                    {!hasMore && item_list.length === 0 && (
                      <div style={{ padding: "8px", color: "#888" }}>No results</div>
                    )}
                  </div>
                </td> */}






                            {/* //////////////////////// */}
                               
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={accounts || []}
                                label="Account"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                value={formData.account}
                                onChange={(value) => onInputChange('account', value)}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Abbr"
                                label="Abbr"
                                style={{ height: "30px" }}
                                value={formData.abbr}
                                onChange={(e) => onInputChange('abbr', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Warehouse Contact Info</p>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Phone No."
                                label="Phone No."
                                style={{ height: "38px" }}
                                value={formData.phoneNo}
                                onChange={(e) => onInputChange('phoneNo', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Mobile No."
                                label="Mobile No."
                                style={{ height: "38px" }}
                                value={formData.mobileNo}
                                onChange={(e) => onInputChange('mobileNo', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Address Line 1"
                                label="Address Line 1"
                                style={{ height: "38px" }}
                                value={formData.addressLine1}
                                onChange={(e) => onInputChange('addressLine1', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Address Line 2"
                                label="Address Line 2"
                                style={{ height: "38px" }}
                                value={formData.addressLine2}
                                onChange={(e) => onInputChange('addressLine2', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="County"
                                label="County"
                                style={{ height: "38px" }}
                                value={formData.county}
                                onChange={(e) => onInputChange('county', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="State/Province"
                                label="State/Province"
                                style={{ height: "38px" }}
                                value={formData.stateProvince}
                                onChange={(e) => onInputChange('stateProvince', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="City/Town"
                                label="City/Town"
                                style={{ height: "38px" }}
                                value={formData.cityTown}
                                onChange={(e) => onInputChange('cityTown', e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Postal Code"
                                label="Postal Code"
                                style={{ height: "38px" }}
                                value={formData.postalCode}
                                onChange={(e) => onInputChange('postalCode', e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default Tab1;